import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/iview-loader/index.js??ref--1-1!./shrinkable-menu.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/iview-loader/index.js??ref--1-1!./shrinkable-menu.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/views/components/shrinkable-menu/shrinkable-menu.vue?vue&type=script&lang=js
// module id = null
// module chunks = 